import * as Sentry from '@sentry/nextjs';
import { useSetAtom } from 'jotai';

import useIsomorphicLayoutEffect from 'src/hooks/useIsomorphicLayoutEffect';
import { handleLoginResultAtom } from 'src/stores/auth/atoms';
import { AzarUser } from 'src/types/AzarUser';

const useWebviewLoginResponse = () => {
  const handleLoginResult = useSetAtom(handleLoginResultAtom);

  // TODO: effect가 아닌 다른 방법 개선 고민
  useIsomorphicLayoutEffect(() => {
    if (!window.AzarJs?.getLoginResponseJson) return;

    let loginResponse: string | undefined;

    try {
      loginResponse = window.AzarJs.getLoginResponseJson();

      if (loginResponse) {
        handleLoginResult({
          data: {
            result: JSON.parse(loginResponse) as AzarUser,
            jsonrpc: '2.0',
            id: 0,
          },
        });
      }
    } catch (e) {
      if (loginResponse) {
        Sentry.captureMessage(
          `Unexpected LoginResponseJson from AzarJs ${e}, userId: ${loginResponse.substr(loginResponse.indexOf('userId'))}, ${loginResponse}`
        );
      }
    }
  }, [handleLoginResult]);
};

export default useWebviewLoginResponse;
